export interface BuildInfo {
  buildNumber: number;
  version: string;
  buildTimestamp: string;
}

export type BuildEnvironment = 'development' | 'test' | 'uat' | 'production' | 'native' | 'pwa';

export const environmentBuildInfo: Record<BuildEnvironment, BuildInfo> & { activeEnvironment: BuildEnvironment } = {
  development: { buildNumber: 2, version: '0.0.2', buildTimestamp: '20260506T093842' },
  test: { buildNumber: 126, version: '1.2.6', buildTimestamp: '20260808T183832' },
  uat: { buildNumber: 0, version: '0.0.0', buildTimestamp: '' },
  production: { buildNumber: 0, version: '0.0.0', buildTimestamp: '' },
  native: { buildNumber: 498, version: '4.9.8', buildTimestamp: '20260331T150232' },
  pwa: { buildNumber: 2, version: '0.0.2', buildTimestamp: '20261030T004441' },
  activeEnvironment: 'pwa'
};
